import styled from "styled-components";

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
export const Progress = styled.div`
  width: 100%;
  height: 4px;
  background-color: #f5f5f5;
`;
export const InnerBar = styled.div<{ percent: number }>`
  height: 100%;
  width: ${props => `${props.percent}%`};
  background-color: #1890ff;
  transition: width 0.6s;
`;
